module.exports = __webpack_public_path__ + "img/pin-location.5381ebd5.svg";